import { useMutation, MutationHookOptions } from '@apollo/client';
import MUTATION from '../operations/ConnectExternalServiceToAccount.graphql';
import { Mutation, MutationconnectExternalServiceToAccountArgs } from '../../__generated__/globalTypes';

export const useConnectExternalServiceToAccountMutation = (
  options?: MutationHookOptions<Mutation, MutationconnectExternalServiceToAccountArgs>
) => {
  const [callConnectExternalServiceToAccount, result] = useMutation<
    Mutation,
    MutationconnectExternalServiceToAccountArgs
  >(MUTATION, options);

  return { callConnectExternalServiceToAccount, ...result };
};

export type ConnectExternalServiceToAccountMutationFunction = Mutation['connectExternalServiceToAccount'];
